import calendarBlack from 'src/assets/images/common/calendar-black.svg'
import downloadBlue from 'src/assets/images/common/downloadBlue.svg'
import downloadGray from 'src/assets/images/common/downloadGray.svg'
import download from 'src/assets/images/common/downloadWhite.svg'
import fireIcon from 'src/assets/images/common/fire.svg'
import isReplacedEquipment from 'src/assets/images/common/isReplacedEquipment.svg'
import list from 'src/assets/images/common/list.svg'
import listGray from 'src/assets/images/common/listGray.svg'
import shevronDown from 'src/assets/images/common/shevronDown.svg'
import shevronRight from 'src/assets/images/common/shevronRight.svg'
import fullSubsidy from 'src/assets/images/financialSource/fullSubsidy.svg'
import isExpiredAssign from 'src/assets/images/isExpiredAssign.svg'
import isSuspicious from 'src/assets/images/isSuspicious.svg'
import newRequestGray from 'src/assets/images/orderStatuses/newGray.svg'
import newRequest from 'src/assets/images/orderStatuses/newWhite.svg'
import warn from '../assets/images/agreementCheckingStatuses/agreement-checking-status-0.svg'
import agreement from '../assets/images/common/agreement.svg'
import {
  default as arrowDown,
  default as tableSettings,
} from '../assets/images/common/arrow-down.svg'
import arrowLeftBlue from '../assets/images/common/arrow-left-blue.svg'
import arrowLeft from '../assets/images/common/arrowLeft.svg'
import arrowLeftBlack from '../assets/images/common/arrowLeftBlack.svg'
import avatarIcon from '../assets/images/common/avatar.svg'
import check from '../assets/images/common/check.svg'
import comment from '../assets/images/common/comment.svg'
import copyTable from '../assets/images/common/copy.svg'
import copy from '../assets/images/common/copygray.svg'
import crossDark from '../assets/images/common/cross_dark.svg'
import crossLight from '../assets/images/common/cross_light.svg'
import dataCheckingIconAccept from '../assets/images/common/dataCheckingIcon-accept.svg'
import dataCheckingIconQuestion from '../assets/images/common/dataCheckingIcon-question.svg'
import downIcon from '../assets/images/common/daw-down-black.svg'
import dealerAvatarSmall from '../assets/images/common/dealerAvatarSmall.svg'
import editWhite from '../assets/images/common/edit-white.svg'
import editIcon from '../assets/images/common/edit.svg'
import editBlue from '../assets/images/common/editWhite.svg'
import enter from '../assets/images/common/enter.svg'
import fileIcon from '../assets/images/common/file-icon.svg'
import goSomewhere from '../assets/images/common/goSomewhere.svg'
import handBook from '../assets/images/common/handBook.svg'
import confirmationInfo from '../assets/images/common/info_blue.svg'
import lupe from '../assets/images/common/lupe.svg'
import searchWhite from '../assets/images/common/lupeWhite.svg'
import massCreated from '../assets/images/common/massCreated.svg'
import commentMessage from '../assets/images/common/message-circle.svg'
import search from '../assets/images/common/notStrict.svg'
import toArchive from '../assets/images/common/pack_in.svg'
import archive from '../assets/images/common/pack_out.svg'
import printerReplaced from '../assets/images/common/printer-replaced.svg'
import printer from '../assets/images/common/printer.svg'
import removed from '../assets/images/common/removed.svg'
import saveIconDisabled from '../assets/images/common/save-icon-disable.svg'
import saveIcon from '../assets/images/common/save-icon.svg'
import selectArrow from '../assets/images/common/selectArrow.svg'
import tooltipIcon from '../assets/images/common/tooltipIcon.svg'
import userIconGrey from '../assets/images/common/userIconGrey.svg'
import fullDotation from '../assets/images/EnteringOperationalData/FullDotation.svg'
import partialDotation from '../assets/images/EnteringOperationalData/PartialDotation.svg'
import exchange from '../assets/images/financialSource/exchange.svg'
import typeSubsidy from '../assets/images/financialSource/typeSubsidy.svg'
import stickIcon from '../assets/images/mapIcons/stick.svg'
import right from '../assets/images/pageSwitch/chevron-right.svg'
import left from '../assets/images/pageSwitch/chevron.svg'
import addToReport from '../assets/images/reportStatuses/addToReport.svg'
import addToReportGray from '../assets/images/reportStatuses/addToReportGray.svg'
import cross from '../assets/images/reportStatuses/cross.svg'
import deleteIcon from '../assets/images/reportStatuses/delete.svg'
import exitReport from '../assets/images/reportStatuses/exitReport.svg'
import massDelete from '../assets/images/reportStatuses/massDelete.svg'
import openReportInformation from '../assets/images/reportStatuses/openReportInformation.svg'
import serviceIcon from '../assets/images/service/serviceIcon.svg'
import serviceIconGray from '../assets/images/service/serviceIconGray.svg'

export const getImageSrc = (type) => {
  switch (type) {
    case 'confirmationInfo':
      return confirmationInfo
    case 'check':
      return check
    case 'massCreated':
      return massCreated
    case 'to-archive':
      return toArchive
    case 'printer':
      return printer
    case 'printerReplaced':
      return printerReplaced
    case 'full-dotation':
      return fullDotation
    case 'partial-dotation':
      return partialDotation
    case 'exchange':
      return exchange
    case 'typeSubsidy':
      return typeSubsidy
    case 'removed':
      return removed
    case 'agreement':
      return agreement
    case 'user':
      return userIconGrey
    case 'handbook':
      return handBook
    case 'isReplacedEquipment':
      return isReplacedEquipment
    case 'date-picker':
      return calendarBlack
    case 'lupe':
      return lupe
    case 'select-arrow':
      return selectArrow
    case 'archive':
      return archive
    case 'enter':
      return enter
    case 'service-icon':
      return serviceIcon
    case 'service-icon-gray':
      return serviceIconGray
    case 'copy-table':
      return copyTable
    case 'table-arrow':
      return tableSettings
    case 'fire':
      return fireIcon
    case 'delete':
      return deleteIcon
    case 'dealer':
      return avatarIcon
    case 'shevronDown':
      return shevronDown
    case 'shevronRight':
      return shevronRight
    case 'new-request':
      return newRequest
    case 'new-request-gray':
      return newRequestGray
    case 'download':
      return download
    case 'download-gray':
      return downloadGray
    case 'download-blue':
      return downloadBlue
    case 'close':
      return cross
    case 'close-light':
      return crossLight
    case 'close-dark':
      return crossDark
    case 'down':
      return openReportInformation
    case 'downIcon':
      return downIcon
    case 'back':
      return exitReport
    case 'isSuspicious':
      return isSuspicious
    case 'isDangerous':
      return isSuspicious
    case 'isExpiredAssign':
      return isExpiredAssign
    case 'right':
      return right
    case 'left':
      return left
    case 'arrow-left-blue':
      return arrowLeftBlue
    case 'dealer-small':
      return dealerAvatarSmall
    case 'copy':
      return copy
    case 'warn':
      return warn
    // это серая иконка
    case 'edit':
      return editIcon
    // это голубая иконка
    case 'edit-white':
      return editBlue
    // это белая иконка
    case 'edit-clear-white':
      return editWhite
    case 'go-somewhere':
      return goSomewhere
    case 'full-subsidy':
      return fullSubsidy
    case 'calendar':
      return calendarBlack
    case 'file-icon':
      return fileIcon
    case 'comment':
      return comment
    case 'comment-message':
      return commentMessage
    case 'tooltip':
      return tooltipIcon
    case 'dcs-accept':
      return dataCheckingIconAccept
    case 'dcs-question':
      return dataCheckingIconQuestion
    case 'stick':
      return stickIcon
    case 'addToReport':
      return addToReport
    case 'addToReportGray':
      return addToReportGray
    case 'massDelete':
      return massDelete
    case 'arrow-left':
      return arrowLeft
    case 'arrow-left-black':
      return arrowLeftBlack
    case 'arrowDown':
      return arrowDown
    case 'save':
      return saveIcon
    case 'save-disabled':
      return saveIconDisabled
    case 'search':
      return search
    case 'search-white':
      return searchWhite
    case 'list':
      return list
    case 'listGray':
      return listGray
  }
}
